<template>
    <!-- bdsm结果页面 -->
    <div class="container">
        <!-- <div class="nav">
            <img src="../assets/img/08.png" class="img01" @click="back()" alt="">
            <div>MBTI人格测试</div>
        </div> -->
        <div class="bg">
            <img src="../assets/img/30.png" class="top" alt="">
            <div class="title">MBTI测试结果</div>
            <div class="div1">
                <div class="left"><img :src="require('../assets/img/' + url + '.png')" alt="" v-if="url"></div>
                <div class="right">
                    <div class="title">{{ dataRes.name }}</div>
                    <div class="type">{{ dataRes.type }}</div>
                    <div class="summary">{{ dataRes.summary }}</div>
                </div>

            </div>
            <div class="describe">
                <div><img src="../assets/img/32.png" alt=""></div>
                <div class="text">{{ dataRes.characteristic }}</div>
            </div>
            <div  class="describe">
                <div><img src="../assets/img/33.png" alt="" class="spe"></div>
                <div  class="text">{{ dataRes.field }}</div>
            </div>
            <div  class="describe">
                <div><img src="../assets/img/34.png" alt=""></div>
                <div  class="text">{{ dataRes.job }}</div>
            </div>
            <!-- 二维码 -->
            <img src="../assets/img/29.png" class="img29" alt="">
        </div>
    </div>
</template>

<script>
import { getAnswerMbti } from "@/api/api.js";
export default {
    name: 'HelloWorld',
    data() {
        return {
            answerArr: [],//问题
            index: 0,
            url: "",
            dataRes: {},

        }
    },
    mounted() {

        this.submit()
    },
    methods: {
        initChart() {

        },
        back() {
            this.$router.go(-1)
        },

        submit() {
            let data = { act: "result", result: this.$route.params.resultArr }
            getAnswerMbti(data).then((res) => {
                if (res.data.status == 0) {
                    this.dataRes = res.data.result;
                    this.url = this.dataRes.type;
                }


            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top{
    width: 100%;
}
.img29{
    width: 3.38rem;
    margin: 0.3rem auto;
}

.describe{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.describe img{
    width: 100%;
    margin: 0.1rem 0rem;
}
 
.describe .text{
    font-size: 14px;
    color: rgba(63, 62, 69, 1);
    font-weight: 400;
    line-height: 0.23rem;
    width: 3.45rem;
    margin: 0px auto;
}
.div1 {
    display: flex;
    justify-content: space-between;
    padding: 0.1rem 0.2rem;
}

.div1 .title {
    font-size: 28px;
    font-weight: 600;
    text-align: left;
}

.div1 .type {
    font-size: 16px;
    font-weight: 600;
    color: rgba(132, 208, 86, 1);
    text-align: left;

}

.div1 .right {
    width: 2.05rem;
}

.div1 .right .summary {
    font-size: 12px;
    color: rgba(63, 62, 69, 1);
    font-weight: 400;
    line-height: 0.23rem;
}

.bg>.title {
    font-size: 16px;
    font-weight: 600;
    margin: 0.2rem 0rem 0.2rem 0.2rem;
}

/* 导航 */
.nav {
    height: 0.44rem;
    display: flex;
    align-items: center;
}

.nav div {
    width: 100%;
    font-size: 22px;
    text-align: center;
    position: relative;
    line-height: 0.44rem;
    text-align: center;
}

.img01 {
    width: 0.22rem;
    position: absolute;
    left: 0.15rem;
    z-index: 3;
}
</style>